import React from "react";
import { Close } from "@mui/icons-material";
import { Chip as Chip$1, Box } from "@mui/material";
import { StyledTooltip } from "../tooltip/Tooltip.js";
import { useChipStyles } from "./Chips.style.js";
import { ChipType } from "./types.js";
function Chip({ fillWidth = true, cursorPointer, ...props }) {
  const { classes: chipClasses, cx } = useChipStyles(props);
  const { chipType, startIconClass, className, isCrossedOut, classes, ...otherProps } = props;
  const typeClassName = chipClasses[`chipType${ChipType[chipType]}`];
  const deleteIcon = props.deleteIcon ? props.deleteIcon : /* @__PURE__ */ React.createElement(Close, null);
  return /* @__PURE__ */ React.createElement(
    Chip$1,
    {
      className: cx(typeClassName, chipClasses.chipVariantColor, {
        [className]: !!className,
        [chipClasses.chipCursorPointer]: cursorPointer
      }),
      variant: "outlined",
      size: "small",
      color: "default",
      icon: startIconClass ? /* @__PURE__ */ React.createElement(Box, { component: "span", className: startIconClass }) : null,
      "data-testid": "chip",
      ...otherProps,
      classes: {
        label: cx(isCrossedOut && chipClasses.chipLabelCrossedOut, classes?.label),
        icon: cx(chipClasses.chipIcon, classes?.icon),
        ...classes
      },
      style: { width: fillWidth ? "100%" : "unset" },
      deleteIcon
    }
  );
}
const ChipWithRef = React.forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Chip, { ...props, ref });
});
function ChipWithTooltip({ title, hideTooltip, ...chipProps }) {
  return /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      element: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ChipWithRef, { ...chipProps })),
      title,
      hideTooltip
    }
  );
}
export {
  Chip,
  ChipWithTooltip
};
//# sourceMappingURL=Chips.js.map
